module.exports = __webpack_public_path__ + "static/media/03s.9d28b80a.png";